import { apiErrorToToast } from "@/lib/utils";
import { createResourceFile } from "@/requests/libraries/create-resource-file.request";
import { ApiErrorResponse } from "@/types/apis";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

export const useCreateResourceFileMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createResourceFile,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [
          "companies",
          variables.companyId,
          "resource-libraries",
          variables.resourceLibraryId,
          "resources",
        ],
      });
    },
    onError: (error: AxiosError<ApiErrorResponse>) => {
      apiErrorToToast(error);
    },
  });
};
